const INTERACTIVE_CHROME_SELECTOR =
  '[data-editor-chrome]:not([data-frame-label]), [data-drop-slot], [data-image-handles], [data-text-toolbar-mount]';

const INTERACTIVE_CHROME_PRESERVE_SLOTS_SELECTOR =
  '[data-editor-chrome]:not([data-frame-label]), [data-image-handles], [data-text-toolbar-mount]';

export function normalizeGhostDropSlots(root: HTMLElement): void {
  root.querySelectorAll('[data-drop-slot] [data-state]').forEach(el => {
    if (el instanceof HTMLElement) {
      el.setAttribute('data-state', 'idle');
    }
  });
}

export function stripInteractiveChrome(
  root: HTMLElement,
  preserveDropSlots: boolean,
): void {
  const selector = preserveDropSlots
    ? INTERACTIVE_CHROME_PRESERVE_SLOTS_SELECTOR
    : INTERACTIVE_CHROME_SELECTOR;
  root.querySelectorAll(selector).forEach(el => el.remove());
  root.querySelectorAll('[data-frame-content]').forEach(el => {
    if (el instanceof HTMLElement) {
      el.style.opacity = '1';
    }
  });
  stripGhostSelectionPreviewChrome(root);
}

export function stripGhostSelectionPreviewChrome(root: HTMLElement): void {
  root.querySelectorAll('.email-builder-canvas-frame').forEach(el => {
    if (!(el instanceof HTMLElement)) {
      return;
    }
    el.removeAttribute('data-hovered');
    el.removeAttribute('data-descendant-hovered');
    el.removeAttribute('data-subselected');
    el.removeAttribute('data-drop-target');
    el.removeAttribute('data-stack-anchor');
    el.removeAttribute('data-selected');
  });
  root.querySelectorAll('.email-builder-selection-edge-strip').forEach(el => {
    el.remove();
  });
}

export function positionClone(
  clone: HTMLElement,
  sourceRect: DOMRect,
  boundsRect: DOMRect,
): void {
  clone.style.position = 'absolute';
  clone.style.left = `${sourceRect.left - boundsRect.left}px`;
  clone.style.top = `${sourceRect.top - boundsRect.top}px`;
  clone.style.width = `${sourceRect.width}px`;
  clone.style.height = `${sourceRect.height}px`;
  clone.style.margin = '0';
  clone.style.opacity = '1';
}

export function combinedBoundsFromRects(rects: DOMRect[]): DOMRect | null {
  if (rects.length === 0) {
    return null;
  }
  const left = Math.min(...rects.map(rect => rect.left));
  const top = Math.min(...rects.map(rect => rect.top));
  const right = Math.max(...rects.map(rect => rect.right));
  const bottom = Math.max(...rects.map(rect => rect.bottom));
  return new DOMRect(left, top, right - left, bottom - top);
}
